import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AgentSelectionStoreState {
  /**
   * Map of userId -> selected agent ID.
   * - `undefined`: no selection stored for this user yet
   * - `string`: specific agent ID stored
   * - `null`: user explicitly selected no agent
   */
  selectedAgentByUser: Record<string, string | null>;
  setSelectedAgentId: (userId: string, agentId: string | null) => void;
  getSelectedAgentId: (userId: string) => string | null | undefined;
  hasUserSelection: (userId: string) => boolean;
  clearUserSelection: (userId: string) => void;
  reset: () => void;
}

export const useAgentSelectionStore = create<AgentSelectionStoreState>()(
  persist(
    (set, get) => ({
      selectedAgentByUser: {},
      setSelectedAgentId: (userId: string, agentId: string | null) => {
        if (!userId) return;
        set((state) => ({
          selectedAgentByUser: {
            ...state.selectedAgentByUser,
            [userId]: agentId,
          },
        }));
      },
      getSelectedAgentId: (userId: string) => {
        if (!userId) return undefined;
        return get().selectedAgentByUser[userId];
      },
      hasUserSelection: (userId: string) => {
        if (!userId) return false;
        return Object.prototype.hasOwnProperty.call(get().selectedAgentByUser, userId);
      },
      clearUserSelection: (userId: string) => {
        if (!userId) return;
        set((state) => {
          const next = { ...state.selectedAgentByUser };
          delete next[userId];
          return { selectedAgentByUser: next };
        });
      },
      reset: () => {
        set({ selectedAgentByUser: {} });
      },
    }),
    {
      name: 'agent-selection-storage',
    }
  )
);
